<template>
    <div>
        <!-- This is a dummy element to help position the tour step for the main navigation menu. //-->
        <div id="v-step-4" style="position:absolute;left:-5px;top:150px;"></div>
        <v-row justify="center" align="stretch">
            <v-col cols="12" id="v-step-5">
                <v-card class="pa-5" elevation="3">
                    <v-row justify="center">
                        <!--opens demo menu -->
                        <v-menu offset-y v-if="submenu.length > 0">
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" depressed absolute top right>
                                    <v-icon id="v-step-9">fas fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-for="(sub, key) in submenu" :key="key" @click.stop="goTo(sub)" @mouseover="hover = true" @mouseleave="hover = false">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <span class="item-title">
                                                {{ sub.label }}
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <!--/opens demo menu -->
                        <v-col cols="12" :lg="has_content_lists ? 8 : 12" class="d-flex align-content-center flex-wrap px-5" style="position:relative">
                            <q-page-slider :slug="current_tenant.ID + '-homepage-slider'" ref="sliderpage"></q-page-slider>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <v-row v-if="has_content_lists" justify="center" align="stretch">
                                <v-col cols="12" sm="6" lg="12" v-if="tenantHasFeature('Contests', current_tenant.ID)">
                                    <q-contest-list></q-contest-list>
                                </v-col>
                                <v-col cols="12" sm="6" lg="12" class="pt-0 mt-0" v-if="tenantHasFeature('News', current_tenant.ID)">
                                    <q-news-list></q-news-list>
                                </v-col>
                                <v-col cols="12" sm="6" lg="12" class="pt-0 mt-0" v-if="tenantHasFeature('Events', current_tenant.ID)">
                                    <q-event-list></q-event-list>
                                </v-col>
                                <v-col cols="12" sm="6" lg="12" class="pt-0 mt-auto">
                                    <h3 class="with-short-rule">Contact Us</h3>
                                    <v-card class="pa-5" flat color="grey lighten-4">
                                        <div :class="{'align-center': !accountManager}" class="d-flex">
                                            <div v-if="accountManager" class="flex-grow-1 mr-2">
                                                <h4 class="mb-0 secondary--text">{{ accountManager.name }}</h4>
                                                <p>Your Account Manager</p>
                                            </div>
                                            <div v-else class="flex-grow-1 mr-2">
                                                For questions or issues, please email <a href="mailto:B2B@quility.com">
                                                    <strong class="secondary--text">B2B@quility.com</strong>
                                                </a>
                                            </div>
                                            <v-img
                                                v-if="accountManager && accountManager.avatar"
                                                :src="accountManager.avatar" height="75px"  width="75px"></v-img>
                                            <img v-else src="@/assets/images/contact_graphic.svg" height="75px"  width="75px" />
                                        </div>
                                        <div v-if="accountManager">
                                            <a :href="`mailto:${accountManager.email}`" class="d-block decoration-none">
                                                <small class="grey--text">{{ accountManager.email }}</small>
                                            </a>
                                            <a v-if="accountManager.phone" :href="`tel:${accountManager.phone}`" class="d-block decoration-none">
                                                <small class="grey--text">{{ accountManager.phone }}</small>
                                            </a>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center" align="stretch">
            <v-col cols="12">
                <v-card class="pa-4" elevation="1" color="grey lighten-5">
                    <v-col cols="12" class="pa-1">
                        <h3 class="with-short-rule">My Policies</h3>
                    </v-col>
                    <v-row justify="center" align="stretch">
                        <v-col cols="4">
                            <v-card class="pa-4" elevation="1" height="100%">
                                <v-row justify="center" align="stretch" class="mb-2">
                                    <v-icon style="font-size: 5rem!important;" color="primary">icon-q-illo-submitted-policies</v-icon>
                                </v-row>
                                <v-btn
                                    to="/new_business/my_submitted_policy"
                                    color="secondary"
                                    width="100%"
                                    @click="$amplitude.track('B2B_SubmittedButton')"
                                >
                                    View Submitted Policies
                                    <v-icon>icon-q-right-arrow</v-icon>
                                </v-btn>
                            </v-card>
                        </v-col>
                        <v-col cols="4">
                            <v-card class="pa-4" elevation="1" height="100%">
                                <v-row justify="center" align="stretch" class="mb-2">
                                    <v-icon style="font-size: 5rem!important;" color="primary">icon-q-illo-pending-policies</v-icon>
                                </v-row>
                                <v-btn
                                    to="/new_business/my_pending_policy"
                                    color="secondary"
                                    width="100%"
                                    @click="$amplitude.track('B2B_PendingButton')"
                                >
                                    View Pending Policies
                                    <v-icon>icon-q-right-arrow</v-icon>
                                </v-btn>
                            </v-card>
                        </v-col>
                        <v-col cols="4">
                            <v-card class="pa-4" elevation="1" height="100%">
                                <v-row justify="center" align="stretch" class="mb-2">
                                    <v-icon style="font-size: 5rem!important;" color="primary">icon-q-illo-placed-policies</v-icon>
                                </v-row>
                                <v-btn
                                    to="/new_business/my_placed_policy"
                                    color="secondary"
                                    width="100%"
                                    @click="$amplitude.track('B2B_PlacedButton')"
                                >
                                    View Placed Policies
                                    <v-icon>icon-q-right-arrow</v-icon>
                                </v-btn>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row wrap justify="center" align="stretch" v-if="tenantHasFeature('Homepage', current_tenant.ID)">
            <v-col cols="12">
                <q-page :slug="current_tenant.ID + '-homepage'"></q-page>
            </v-col>
        </v-row>
        <!-- Stats -->
        <!-- <v-row wrap justify="center" align="stretch" v-if="notRole('UnlicensedAgent') && tenantHasFeature('Stats', current_tenant.ID)">
            <v-col cols="12">
                <v-card class="mx-auto ma-1" elevation="3" height="100%">
                    <v-col cols="12" class="primary pa-1" id="v-step-6">
                        <p class="q-display-3 pl-5 pt-3">
                            My Stats
                            <v-btn icon to="/my_stats/scorecard/new_business">
                                <v-icon class="on-primary--text">fas fa-arrow-circle-right</v-icon>
                            </v-btn>
                        </p>
                    </v-col>
                    <score-cards-new-business :show-submenu="false" :allowAgentLookup="false"></score-cards-new-business>
                </v-card>
            </v-col>
        </v-row> -->
        <!-- Leaderboards-->
        <v-row wrap v-if="tenantHasFeature('Leaderboards', current_tenant.ID)">
            <v-col cols="12">
                <q-leaderboard-explorer></q-leaderboard-explorer>
            </v-col>
        </v-row>
        <v-overlay opacity=".8" :value="!data_loaded">
            Loading...
            <v-progress-circular indeterminate></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import QContestList from '@/components/lists/QContestList.vue';
import QNewsList from '@/components/lists/QNewsList.vue';
import QEventList from '@/components/lists/QEventList.vue';
import QPageSlider from '@/components/utils/QPageSlider.vue';
import QPage from '@/CMS/views/index-no-template.vue';
import QLeaderboardExplorer from '@/views/MyStats/QLeaderboardExplorer.vue';
import ScoreCardsNewBusiness from '@/views/MyStats/ScoreCards_NewBusiness.vue';
import EventPage from '@/store/Models/EventPage'
import ContestPage from '@/store/Models/ContestPage'
import NewsPage from '@/store/Models/NewsPage'
import Category from '@/store/Models/Category'

export default {
    name: 'Dashboard',

    components: {
        QContestList,
        QNewsList,
        QPageSlider,
        QEventList,
        QLeaderboardExplorer,
        ScoreCardsNewBusiness,
        QPage
    },

    props: {
        to: {
            type: String,
            default: null,
        },
        baseUrl: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            message: `Your last logon was ${new Date().toLocaleString()}`,
            counter: 0,
            sheet: false,
            data_loaded: true,
            submenu: [{
                label: "Help",
                to: "/page/frequently-asked-questions",
            }],
        };
    },

    mounted() {
        // if the user has not already seen this tour it will automatically start.
        this.maybeAutoStartDemo('DemoDashboard');
    },

    computed: {
        has_content_lists: function() {
            return this.tenantHasFeature('Contests', this.current_tenant.ID) ||
                this.tenantHasFeature('News', this.current_tenant.ID) ||
                this.tenantHasFeature('Events', this.current_tenant.ID)
        },
        has_contests: function() {
            var g = this
            return ContestPage.query()
                .where('category_id', this.contest_category_id)
                .where('tenant_id', g.current_tenant.ID)
                .get().length > 0
        },
        has_events: function() {
            var g = this
            return ContestPage.query()
                .where('category_id', this.event_category_id)
                .where('tenant_id', g.current_tenant.ID)
                .get().length > 0
        },
        has_news: function() {
            var g = this
            return ContestPage.query()
                .where('category_id', this.news_category_id)
                .where('tenant_id', g.current_tenant.ID)
                .get().length > 0
        },
        loading: function() {
            return this.$store.state.entities.contest_page.loading;
        },
        contest_category_id: function() {
            var category = Category.query().where('category', 'Contests').first();
            if (category == null) {
                return -1
            }
            return category.id;
        },
        events_category_id: function() {
            var category = Category.query().where('category', 'Events').first();
            if (category == null) {
                return -1
            }
            return category.id;
        },
        news_category_id: function() {
            var category = Category.query().where('category', 'News').first();
            if (category == null) {
                return -1
            }
            return category.id;
        },
    },

    methods: {
        // starts the demo tour when the option in the ellipsis menu is clicked.
        startDemo() {
            this.$tours.DemoDashboard.start();
        },

        goTo(target) {
            if (target.anchor) {
                if (!this.isBase) {
                    this.$router.push(this.baseUrl + target.anchor);
                } else {
                    this.$vuetify.goTo(target.anchor, { easing: 'easeInOutCubic', offset: 80 });
                }
            }
            if (target.to) {
                this.$router.push(target.to);
            }
            if (target.href) {
                window.open(target.href, '_blank');
            }
            if (target.fun) {
                target.fun();
            }
        },
    },
};
</script>
<style>
h4 {
    margin-bottom: 10px;
}

h1.with-short-rule::after,
h2.with-short-rule::after,
h3.with-short-rule::after,
h4.with-short-rule::after,
h5.with-short-rule::after {
    padding: .2em;
    display: block;
    width: 6%;
    height: 1px;
    content: " ";
    background-color: #DAF3F0;
    margin: 4px 0 8px 0;
}
</style>